module.exports = __webpack_public_path__ + "media/images/icon-practices-f0f19bb52eb8ad34ae61a83230f43c2f.svg";